import {useQuery} from '@tanstack/react-query';
import {GraphResponse, GraphViewKind} from '../../../../../../components/graph/interface';
import {apiClient} from '../../../../../../utils/api-client';
import {NeighborhoodGraphDirection} from '../interface';

interface Props {
    documentId: string;
    factIds: string[];
    globalVersionId: number;
    viewKind: GraphViewKind;
    maxDistance: number;
    direction: NeighborhoodGraphDirection;
}

function requestNeighborhoodGraph(
    documentId: string,
    factsId: string[],
    globalVersionId: number,
    selectedViewKind: GraphViewKind,
    maxDistance: number,
    direction: NeighborhoodGraphDirection
) {
    return apiClient
        .get<GraphResponse>({
            path: `/queries-service/api/documents/${documentId}/connection-graph/${selectedViewKind}`,
            query: {
                depth: maxDistance,
                direction,
                'global-version': globalVersionId,
                'fact-ids': factsId[0]
            }
        })
        .then((response) => ({
            nodes: response.nodes,
            edges: response.edges.map((edge) => ({
                ...edge,
                id: -edge.id
            }))
        }));
}

export function useRequestNeighborhoodGraph(props: Props) {
    return useQuery({
        queryKey: [
            'request-neighborhood-graph',
            props.globalVersionId,
            props.documentId,
            ...props.factIds,
            props.viewKind,
            props.maxDistance,
            props.direction
        ],
        queryFn: () =>
            requestNeighborhoodGraph(
                props.documentId,
                props.factIds,
                props.globalVersionId,
                props.viewKind,
                props.maxDistance,
                props.direction
            )
    });
}
